import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import Accordion from '../../components/common/Accordian';
import PilotForm from '../../components/common/PilotForm';
import AddFormIcon from '../../assets/AddFormIcon';
import AccordianUpIcon from '../../assets/AccordianUpIcon';
import AccordianDownIcon from '../../assets/AccordianDownIcon';
import PhoneIcon from '../../assets/PhoneIcon';
import EditIcon from '../../assets/EditIcon';
import ReusableSelect from '../../components/common/Select';
import CrewPilotDetailsCard from '../../components/common/CrewPiolotCard';

import operationAPI from '../../api/operationApi';
import { IOperations } from '../../type/operation';
import GoogleMapComponent from '../../components/ui/GoogleMapSection';
import { ILocation } from '../../type/location';
import { ITemperature } from '../../type/temperature';
import 'react-toastify/dist/ReactToastify.css';
import { IDutyManager } from '../../type/dutyManager';
import { IMaxMinPaxForPd } from '../../type/minMaxPaxForPdCairns';
import ListView from '../../components/common/ListViewComponent';
import useLocationStore from '../../store/locatonStore';
import {
  CountryPaxSection,
  DateSelector,
  FlightSections,
} from '../../components';
import { ITime } from '../../type/time';
import { IDutyManagerRequest } from '../../type/addDutyManager';
import {
  locationConstant,
  RateId,
  StaffConstant,
} from '../../constants/constant';
import MapIcon from '../../assets/MapIcon';
import MapList from '../../assets/MapList';
import { IAddTemperatureRequest } from '../../type/addTemp';
import CheckIcon from '../../assets/CheckIcon';
import { IStaffAllocation } from '../../type/staffAllocation';
import Toast from '../../components/common/alert/successAlert';
import useTemperatureSecondStore from '../../store/temperatureSecondStore';
import {
  encodeDateForUrl,
  formatStartTime,
  getAdjustedDate,
} from '../../utils/dateUtils';
import { toast } from 'react-toastify';
import { translate } from '../../i18n';
import useDateStore from '../../store/selectedDateStore';
import useDebounce from '../../hooks/useDebounce';
import SunIcon from '../../assets/SunIcon';
import ReusableSelectLocation from '../../components/common/SelectLocation';
import useBgColorStore from '../../store/bgColor';
import CalendarHeader from '../../components/common/Header/CalenderHeader';
import { IFlightDetails } from '../../type/flightDetails';
import EditFormFlight from '../../components/common/EditFormFlight';
import WeatherAndTravelStatus from '../../components/ui/WeatherAndTravel';
import SunIconDark from '../../assets/SunIconDark';
import CheckIconDark from '../../assets/CheckIconDark';
import EditIconDark from '../../assets/EditIconDark';
import AccordianDownIconDark from '../../assets/AccordianDownIconDark';
import AccordianUpIconDark from '../../assets/AccordianUpIconDark';
import PhoneIconDark from '../../assets/PhoneIconDark';
import AddFormIconDark from '../../assets/AddFormIconDark';
import WeatherSection from '../../components/ui/WeatherSection';
import GeneralComment from '../../components/common/GeneralComment';
import { showOrReplaceToast } from '../../utils/utility';
import MapIconDark from '../../assets/MapIconDark';
import MapListDark from '../../assets/MapListDark';
import useTimeStore from '../../store/timeStore';
import { IBookingAvailability } from '../../type/BookingAvailability';
import Loader from '../../assets/loader/Loader';
import PaymentBreakup from '../../components/common/PaymentBreakup';
import BreakFast from '../../components/common/BreakFast';
import OperationCheckListComponent from '../../components/common/OperationCheckList';
import DriverComponent from '../../components/common/DriverComponent';
import CrewComponent from '../../components/common/CrewComponent';
import {
  useBookingRates,
  useOperationDetails,
  useOwnerLocations,
  usePilotAllocation,
  useTemperatureList,
  useTodayTemperature,
} from '../../hooks/apiHook/operationDetails';
import { IUpdateResPhone } from '../../type/addRes';
type ModalType =
  | 'CrewForm'
  | 'DriverForm'
  | 'PilotForm'
  | 'EditFormFlight'
  | null;

const MobileOperations = () => {
  const { bgColor, updateBgColor } = useBgColorStore();
  const { setSelectedDateFromStore } = useDateStore();
  const selectedDateFromStore = useDateStore(
    (state) => state.selectedDateFromStore,
  );
  const [editingBookingId, setEditingBookingId] = useState<number | null>(null);
  const [apiResponse, setApiResponse] = useState<IOperations>();
  const [staffAllocation, setStaffAllocation] = useState<IStaffAllocation[]>();
  const [locationList, setLocationList] = useState<ILocation[]>();
  const [googleDriverLink, setGoogleDriverLink] = useState('');
  const [operationStaffId, setOperationStaffId] = useState<number>();

  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const [isMapView, setIsMapView] = useState(true);
  const [reloadKey, setReloadKey] = useState(0);
  const [IsInputBoxChange, setIsInputBoxChange] = useState<Boolean>(false);
  const selectedLocation = useLocationStore((state) => state.selectedLocation);
  const [selectedDate, setSelectedDate] = useState<Date>(
    selectedDateFromStore || getAdjustedDate(),
  );
  const [operationTime, setOperationTime] = useState<string>('');
  const [refreshCalender, setRefreshCalender] = useState(0);
  const [crewDetails, setCrewDetails] = useState<IStaffAllocation | null>(null);
  const [phoneNumberRes, setPhoneNumberRes] = useState('');
  const [phoneNumberPic, setPhoneNumberPic] = useState('');
  const [phoneNumberDutyManager, setPhoneNumberDutyManager] = useState('');
  const [modalCallback, setModalCallback] = useState<(() => void) | undefined>(
    undefined,
  );
  const [flightDetail, setFlightDetail] = useState<IFlightDetails>();

  type ToastProps = {
    type?: 'info' | 'success' | 'warning' | 'error';
    message?: string;
    title?: string;
    onClose?: () => void;
  };
  const openModal = (modalType: ModalType, staff?: IStaffAllocation) => {
    setActiveModal(modalType);
    setCrewDetails(staff ?? null);
  };
  const openModalFlight = (
    modalType: ModalType,
    flightDetail?: IFlightDetails,
    callback?: () => void,
  ) => {
    setActiveModal(modalType);
    setFlightDetail(flightDetail);
    setModalCallback(() => callback);
  };
  const [showToast, setShowToast] = useState(false);
  const [toastProps, setToastProps] = useState<ToastProps>({});
  const closeModal = () => setActiveModal(null);

  const setSelectedLocation = useLocationStore(
    (state) => state.setSelectedLocation,
  );
  const [selectedLocationId, setSelectedLocationId] = useState<number>(
    selectedLocation?.OwnerId || locationConstant.ownerId,
  );
  const handleLocationChange = (selectedOption: ILocation | null) => {
    if (selectedOption) {
      setSelectedLocationId(selectedOption.OwnerId);
      setSelectedLocation(selectedOption);
      updateBgColor();
    }
  };
  const [ofl, setOfl] = useState('');
  const [isEditWeather, setIsEditWeather] = useState<boolean>(false);
  const [pilotAccordionIsOpen, setPilotAccordionIsOpen] = useState<
    boolean | undefined
  >(false);

  const handleStaffChange = (type: 'driver' | 'pilot' | 'crew' | 'booking') => {
    if (type === 'pilot') {
      setPilotAccordionIsOpen(true);
      refetchPilotAllocation();
    }
  };
  const { setRateId } = useTimeStore();
  const [rateId, setRateIds] = useState<number>(1);
  const handleOperationTimeChange = (selectedTime: ITime) => {
    if (selectedTime?.value && selectedTime.value in RateId) {
      setRateId(RateId[selectedTime.value as keyof typeof RateId]);
      setRateIds(RateId[selectedTime.value as keyof typeof RateId]);
    }
    setOperationTime(selectedTime.value);
  };

  const [bookingData, setBookingData] = useState<IBookingAvailability | null>(
    null,
  );

  useEffect(() => {
    setSelectedDate(selectedDateFromStore);
  }, [selectedDateFromStore]);

  const {
    data: bookingRateData,
    isLoading: bookingRateLoading,
    isFetching,
    error,
    refetch: refetchBookingRates,
  } = useBookingRates(selectedDate, selectedLocation?.OwnerId ?? null, rateId);

  useEffect(() => {
    if (bookingRateData) {
      setBookingData(bookingRateData);
    }
  }, [bookingRateData]);

  const encodedDate = useMemo(
    () => encodeDateForUrl(selectedDate),
    [selectedDate],
  );

  const {
    data: operationDetailsData,
    isLoading,
    isFetching: operationIsFetching,
    refetch,
  } = useOperationDetails(selectedLocation.OwnerId, encodedDate);

  useEffect(() => {
    refetch();
  }, []);

  useEffect(() => {
    if (selectedLocation?.OwnerId || selectedDate) {
      refetch();
    }
  }, [selectedLocation.OwnerId, selectedDate]);

  useEffect(() => {
    if (operationDetailsData) {
      setApiResponse(operationDetailsData); // ✅ update state here
    }
  }, [operationDetailsData]);

  const {
    data: pilotData,
    isLoading: isPilotLoading,
    isFetching: isPilotFetching,
    refetch: refetchPilotAllocation,
  } = usePilotAllocation(selectedLocation.OwnerId, selectedDate);

  useEffect(() => {
    if (pilotData) {
      setStaffAllocation(pilotData);
    }
  }, [pilotData]);

  const {
    data: ownerLocationsData,
    isLoading: isOwnerQueryLoading,
    isFetching: isOwnerQueryFetching,
    refetch: refetchOwnerLocations,
  } = useOwnerLocations();

  // Set local state when data arrives
  useEffect(() => {
    if (ownerLocationsData) {
      setLocationList(ownerLocationsData);
    }
  }, [ownerLocationsData]);

  const handleDateChange = (date: Date | null) => {
    if (date) {
      setSelectedDate(date);
      setSelectedDateFromStore(date);
    }
  };

  const googleDriverLinkSubmitHandler = async (googleDriverLink: string) => {
    try {
      const encodedDate = encodeDateForUrl(selectedDate);
      const response = await operationAPI.googleDriverImage(
        encodedDate,
        googleDriverLink,
        selectedLocation.OwnerId,
      );
      showOrReplaceToast(
        'operations',
        translate('operation.googleDriverAdded'),
        'success',
      );
      setIsInputBoxChange(false);
    } catch (error) {
      toast.warn(translate('operation.commonError'));
    }
  };

  const addDutyManagerHandler = async (
    staffId: number,
    ownerId: number,
    date: string,
    roleId: number,
    operationStaffId?: number,
  ) => {
    try {
      const data: IDutyManagerRequest = {
        staffId,
        ownerId,
        date,
        roleId: roleId,
        operationStaffId: operationStaffId,
      };
      const response = await operationAPI.addDutyManager(data);
      showOrReplaceToast(
        'operations',
        translate('operation.staffAddedSuccessfully'),
        'success',
      );
    } catch (error) {
      console.log(error);
      toast.warn(translate('operation.commonError'));
    }
  };
  const [temp, setTemp] = useState<number>();
  const { selectedTemperature2, setSelectedTemperature2 } =
    useTemperatureSecondStore();
  const [isEditing, setIsEditing] = useState(false);
  const handleEditToggle = () => setIsEditing((prev) => !prev);
  const addTemperature = async (data: IAddTemperatureRequest) => {
    try {
      const response = await operationAPI.addTemperature(data);
      showOrReplaceToast(
        'operations',
        translate('operation.tempAddedSuccessfully'),
        'success',
      );
      refetchTodayTemp();
    } catch (error) {
      toast.warn(translate('operation.commonError'));
    }
  };
  const time: ITime[] = [
    { value: '1h' },
    {
      value: '24h',
    },
    {
      value: '1w',
    },
  ];
  const addResHandler = async (data: IUpdateResPhone) => {
    try {
      const response = await operationAPI.addRes(data);
      console.log(response, 'response');
      showOrReplaceToast(
        'operations',
        translate('operation.staffAddedSuccessfully'),
        'success',
      );
    } catch (error) {
      showOrReplaceToast(
        'operations',
        translate('operation.commonError'),
        'error',
      );
    }
  };
  const [selectedRes, setSelectedRes] = useState<number | undefined>();
  const handleResChange = (selectedValue: IDutyManager) => {
    const encodedDate = encodeDateForUrl(selectedDate);
    setSelectedRes(selectedValue.staffId);
    setRefreshCalender((r) => r + 1);
    setPhoneNumberRes(selectedValue.staffContact);
    const data: IUpdateResPhone = {
      resPhone: selectedValue.staffName + selectedValue.staffContact,
      date: encodedDate,
      ownerId: selectedLocation.OwnerId,
    };
    addResHandler(data);
  };

  const handleOperationStaffIdChange = (operationStaffId: number) => {
    setOperationStaffId(operationStaffId);
  };
  const handlePhoneClick = (phoneNumber: string) => {
    if (phoneNumber) {
      window.location.href = `tel:${phoneNumber}`;
    } else {
      alert('No phone number selected');
    }
  };

  const handleEditClick = (bookingId: number | null) => {
    if (bookingId === null) {
      setEditingBookingId(null);
    } else {
      setEditingBookingId(bookingId);
    }
  };

  const [selectedPic, setSelectedPic] = useState<number | undefined>(undefined);
  const [selectedDutyManager, setSelectedDutyManager] = useState<
    number | undefined
  >(undefined);

  const handleDutyManagerChange = (selectedValue: IDutyManager) => {
    const encodedDate = encodeDateForUrl(selectedDate);
    setSelectedDutyManager(selectedValue.staffId);
    setRefreshCalender((r) => r + 1);
    setPhoneNumberDutyManager(selectedValue.staffContact);
    if (dutyManagerOperationStaffId) {
      addDutyManagerHandler(
        selectedValue.staffId,
        selectedLocation.OwnerId,
        encodedDate,
        StaffConstant.DUTY_MANAGER,
        dutyManagerOperationStaffId,
      );
    } else {
      addDutyManagerHandler(
        selectedValue.staffId,
        selectedLocation.OwnerId,
        encodedDate,
        StaffConstant.DUTY_MANAGER,
      );
    }
  };
  const [dutyManagerOperationStaffId, setDutyManagerOperationStaffId] =
    useState<number>();
  const [resOperationStaffId, setResOperationStaffId] = useState<number>();
  const [picOperationStaffId, setPicOperationStaffId] = useState<number>();
  useEffect(() => {
    if (apiResponse?.staffAllocationOfTheDay) {
      setSelectedDutyManager(
        apiResponse.staffAllocationOfTheDay.dutyManagerStaffId || undefined,
      );
      setDutyManagerOperationStaffId(
        apiResponse.staffAllocationOfTheDay.operationStaffIdDutyManager,
      );
      setPhoneNumberDutyManager(
        apiResponse.staffAllocationOfTheDay.dutyManagerContact,
      );
      setPicOperationStaffId(
        apiResponse?.staffAllocationOfTheDay.picOperationStaffId,
      );
      setSelectedPic(
        apiResponse.staffAllocationOfTheDay.picStaffId || undefined,
      );
      setPhoneNumberPic(apiResponse?.staffAllocationOfTheDay?.picContact);
      setSelectedRes(apiResponse?.resCandidateStaffId || undefined);
      setResOperationStaffId(
        apiResponse?.staffAllocationOfTheDay?.resOperationStaffId,
      );
      setPhoneNumberRes(apiResponse?.staffAllocationOfTheDay?.resStaffContact);
    }
  }, [apiResponse]);

  const handleDutyPicChange = (selectedValue: IDutyManager) => {
    const encodedDate = encodeDateForUrl(selectedDate);
    setSelectedPic(selectedValue.staffId);
    setRefreshCalender((r) => r + 1);
    setPhoneNumberPic(selectedValue.staffContact);
    if (picOperationStaffId) {
      addDutyManagerHandler(
        selectedValue.staffId,
        selectedLocation.OwnerId,
        encodedDate,
        StaffConstant.PIC,
        picOperationStaffId,
      );
    } else {
      addDutyManagerHandler(
        selectedValue.staffId,
        selectedLocation.OwnerId,
        encodedDate,
        StaffConstant.PIC,
      );
    }
  };

  const [initialOfl, setInitialOfl] = useState('');
  useEffect(() => {
    if (apiResponse?.googleDriverLink) {
      setGoogleDriverLink(apiResponse.googleDriverLink);
    }
    const ofl = apiResponse?.ofl
      ? new Date(apiResponse?.ofl).toISOString().substring(11, 16)
      : '';
    setInitialOfl(ofl);
  }, [apiResponse]);
  const isFirstRender = useRef(true);
  const debouncedOfl = useDebounce(ofl, 1500);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    // Call the API only when the user changes the input value and stops typing
    if (debouncedOfl) {
      console.log('API called with value:', debouncedOfl);
      handlerAddOfl(debouncedOfl);
    }
  }, [debouncedOfl]);

  const handlerAddOfl = async (time: string) => {
    try {
      const response = await operationAPI.addOfl({
        toDate: encodeDateForUrl(selectedDate),
        oflTime: await formatStartTime(time),
        ownerId: selectedLocation.OwnerId,
      });
      console.log(response);
      showOrReplaceToast(
        'operations',
        translate('ofl.oflSuccessMessage'),
        'success',
      );
    } catch (error) {
      console.log(error);
      toast.warn(translate('operation.commonError'));
    }
  };

  const [tempList, setTempList] = useState<ITemperature[]>([]);
  const [todayTemp, setTodayTemp] = useState<number>();
  const {
    data: temperatureList,
    isLoading: tempIsLoading,
    isFetching: tempIsFetching,
    isError,
    refetch: refetchTemp,
  } = useTemperatureList();

  useEffect(() => {
    if (temperatureList) {
      setTempList(temperatureList);
    }
  }, [temperatureList]);

  const {
    data: todayTemperature,
    isLoading: todayTempIsLoading,
    isFetching: todayTempIsFetching,
    refetch: refetchTodayTemp,
  } = useTodayTemperature(selectedLocation?.OwnerId, encodedDate);

  const [todaysTemp, setTodaysTemp] = useState<number>();

  useEffect(() => {
    refetchTodayTemp();
  }, []);

  useEffect(() => {
    if (todayTemperature) {
      setTodayTemp(todayTemperature.temperatureid1);
      setTodaysTemp(todayTemperature.temperature1);
    }
  }, [todayTemperature]);

  useEffect(() => {
    refetchTodayTemp();
  }, [selectedLocation?.OwnerId, selectedDate]);

  return (
    <div className="bg-background">
      <div className="bg-background">
        <div className="top-4 z-20">
          {showToast && <Toast {...toastProps} />}
        </div>
        <div className="mt-2">
          <CalendarHeader refreshCalender={refreshCalender} />
        </div>
        {/* w-screen p-4" */}
        <div className={`w-screen p-2 bg-backgroundColor-white`}>
          <div className="text-start">
            <h1 className={`text-lg font-semibold text-text-primary `}>
              {translate('operation.dailyOperation')}
            </h1>
          </div>
          <h1 className="text-base font-semibold text-left text-text-primary ">
            {translate('common.location')}
          </h1>
          <div className="mt-2 bg-background">
            {isOwnerQueryLoading || isOwnerQueryFetching ? (
              <div className="w-full flex justify-center items-center py-4">
                <Loader />{' '}
              </div>
            ) : (
              <ReusableSelectLocation<ILocation>
                options={locationList || ([] as ILocation[])}
                className={`w-full border rounded p-2 text-sm  bg-sidebar-background  text-text-primary border-customBorder-border`}
                getOptionLabel={(option: ILocation) => option.locationName}
                getOptionValue={(option: ILocation) => option.OwnerId}
                onChange={handleLocationChange}
                placeholder="Select a location"
                value={selectedLocationId}
              />
            )}
          </div>
          <div className={`${bgColor} mb-1`}>
            <div
              className={`flex justify-between mt-2   pt-4 rounded w-[100%] gap-4  `}
            >
              <div
                className={` flex items-start space-x-1 h-[44px] w-full p-2 rounded  bg-backgroundColor-darkThemeColor ml-1`}
              >
                <DateSelector
                  onDateChange={handleDateChange}
                  initialDate={selectedDate}
                  // showArrows={true}
                />
              </div>

              <div
                className={`bg-backgroundColor-darkThemeColor flex items-center space-x-1 rounded w-full h-[44px] gap-1 mr-8 mb-1`}
              >
                {/* <p> Load Temp</p> */}
                <span className="text-textColor">
                  <div>
                    <div className="block dark:hidden">
                      <SunIcon />
                    </div>
                    <div className="hidden dark:block">
                      <SunIconDark />
                    </div>
                  </div>
                </span>
                <span className="text-text-darkGray">
                  {translate('operation.loadTemp')}
                </span>
                {todayTempIsLoading || todayTempIsFetching ? (
                  <Loader />
                ) : (
                  <>
                    <p className="text-text-primary">{todaysTemp}°C</p>
                  </>
                )}
              </div>
            </div>
            <div className="bg-backgroundColor-white h-1"></div>
            <div className={`flex  items-center  gap-14  pt-2 rounded`}>
              <div className={`flex justify-around gap-4 p-2`}>
                <label className="text-text-secondary flex justify-center items-center font-semibold">
                  {' '}
                  {translate('ofl.ofl')}
                </label>
                <div className="flex w-full">
                  {isLoading || operationIsFetching ? (
                    <>
                      <Loader />
                    </>
                  ) : (
                    <input
                      type="time"
                      min="00:00"
                      max="11:59"
                      step={60}
                      placeholder={translate('driver.startTimePlaceholder')}
                      value={ofl || initialOfl}
                      className="block w-full p-1 border border-customBorder-border rounded-md hide-ampm ofltime  bg-backgroundColor-darkThemeColor text-text-secondary"
                      onChange={(e) => {
                        setOfl(e.target.value);
                      }}
                    />
                  )}
                </div>
              </div>

              <div>
                <ReusableSelect<ITime>
                  options={time}
                  className="w-full  rounded p-2 text-sm border border-customBorder-border bg-backgroundColor-darkThemeColor text-text-primary"
                  getOptionLabel={(option: ITime) => option.value}
                  getOptionValue={(option: ITime) => option.value}
                  onChange={(selectedOption) => {
                    handleOperationTimeChange(selectedOption);
                  }}
                  placeholder="Select Time"
                  value={operationTime || '1h'}
                />
              </div>
            </div>

            <div className={`${bgColor} " pl-2 rounded"`}>
              {bookingRateLoading || isFetching ? (
                <div className="flex justify-center items-center bg-background p-4">
                  <Loader />
                </div>
              ) : (
                <div className="flex justify-between items-center">
                  <div>
                    <div className="flex justify-between">
                      <h2 className="text-sm text-start font-bold text-text-darkGray">
                        Total Bookings :
                      </h2>
                      <span className="text-text-primary ml-2">
                        {bookingData?.booked}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <h2 className="text-sm text-start font-bold text-text-darkGray">
                        Available Bookings :
                      </h2>
                      <span className="text-text-primary ml-2">
                        {bookingData?.availability}
                      </span>
                    </div>
                  </div>
                  <div className="bg-backgroundColor-darkThemeColor rounded pt-4 pb-4 pr-4 pl-4 mr-7 mb-1">
                    <span className="text-[1.5rem] font-semibold text-calenderColor-topHeader">
                      {bookingData?.increasedBooking != null &&
                        (bookingData.increasedBooking > 0 ? (
                          <span>+{bookingData.increasedBooking}</span>
                        ) : bookingData.increasedBooking < 0 ? (
                          <span className="text-red-500">
                            {bookingData.increasedBooking}
                          </span>
                        ) : (
                          0
                        ))}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className={`${bgColor} w-full mt-4 rounded`}>
            <CountryPaxSection
              selectedDate={selectedDate}
              ownerId={selectedLocation.OwnerId}
            />
          </div>
        </div>

        <div className="mt-4">
          <Accordion
            title={translate('operation.allAllocation')}
            bgColor={`${bgColor}`}
            iconOpen={
              <div>
                <div className="block dark:hidden">
                  <AccordianDownIcon />
                </div>
                <div className="hidden dark:block">
                  <AccordianDownIconDark />
                </div>
              </div>
            }
            iconClose={
              <div>
                <div className="block dark:hidden">
                  <AccordianUpIcon />
                </div>
                <div className="hidden dark:block">
                  <AccordianUpIconDark />
                </div>
              </div>
            }
          >
            {isLoading ? (
              <div className="flex justify-center align-middle">
                <Loader />
              </div>
            ) : (
              <>
                <div className="space-y-4 mx-auto mb-4">
                  {/* Duty Manager */}
                  <div className="flex justify-between items-center">
                    <div className="w-[30%]">
                      <p className="text-text-lightGray font-medium text-sm text-start">
                        {translate('operation.dutyManager')}
                      </p>
                      <p className="text-text-lightGray font-medium text-sm text-start">
                        {apiResponse?.dutyManagerPhoneNumber}
                      </p>
                    </div>

                    <div className=" w-[70%]  flex items-center space-x-2">
                      <ReusableSelect<IDutyManager>
                        options={apiResponse?.dutyManager || []}
                        className={`w-full border border-customBorder-border rounded p-2 text-sm  text-text-primary bg-[var(--bgWhiteBackground)] `}
                        getOptionLabel={(option: IDutyManager) =>
                          `${option.staffName}`
                        }
                        getOptionValue={(option) => option.staffId}
                        onChange={handleDutyManagerChange}
                        placeholder="Duty Manager"
                        value={selectedDutyManager}
                      />
                      <button
                        className="text-textColor hover:text-textColor"
                        onClick={() => handlePhoneClick(phoneNumberDutyManager)}
                      >
                        <div>
                          <div className="block dark:hidden">
                            <PhoneIcon />
                          </div>
                          <div className="hidden dark:block">
                            <PhoneIconDark />
                          </div>
                        </div>
                      </button>
                    </div>
                  </div>

                  {/* Pilot in Command */}
                  <div className="flex justify-between items-center ">
                    <div className="w-[30%]">
                      <p className="text-text-lightGray font-medium text-sm text-start">
                        {translate('operation.pilotInCommand')}
                      </p>
                    </div>

                    <div className="w-[70%] flex items-center space-x-2">
                      <ReusableSelect<IDutyManager>
                        options={apiResponse?.picManager || []}
                        className={`w-full border border-customBorder-border rounded p-2 text-sm  text-text-primary bg-[var(--bgWhiteBackground)] `}
                        getOptionLabel={(option) => `${option.staffName}`}
                        getOptionValue={(option: IDutyManager) =>
                          option.staffId
                        }
                        onChange={handleDutyPicChange}
                        placeholder="Select PIC "
                        value={selectedPic}
                      />
                      <button
                        className="text-textColor hover:text-textColor"
                        onClick={() => {
                          handlePhoneClick(phoneNumberPic);
                        }}
                      >
                        <div>
                          <div className="block dark:hidden">
                            <PhoneIcon />
                          </div>
                          <div className="hidden dark:block">
                            <PhoneIconDark />
                          </div>
                        </div>
                      </button>
                    </div>
                  </div>

                  {/* Reservation */}
                  <div className="flex justify-between items-center">
                    <div className="w-[30%]">
                      <p className="text-textColorGray font-medium text-sm text-start">
                        {translate('operation.reservation')}
                      </p>
                    </div>

                    <div className="w-[70%] flex items-center space-x-2">
                      <ReusableSelect<IDutyManager>
                        options={apiResponse?.resAvailableList || []}
                        className={`w-full border border-customBorder-border rounded p-2 text-sm  text-text-primary bg-[var(--bgWhiteBackground)] `}
                        getOptionLabel={(option) => `${option.staffName}`}
                        getOptionValue={(option: IDutyManager) =>
                          option.staffId
                        }
                        onChange={handleResChange}
                        placeholder="Select Res"
                        value={selectedRes}
                      />
                      <button
                        className="text-textColor hover:text-textColor"
                        onClick={() => {
                          handlePhoneClick(phoneNumberRes);
                        }}
                      >
                        <div>
                          <div className="block dark:hidden">
                            <PhoneIcon />
                          </div>
                          <div className="hidden dark:block">
                            <PhoneIconDark />
                          </div>
                        </div>
                      </button>
                    </div>
                  </div>
                  <div className="flex justify-between items-center  h-[50px]">
                    <div className="w-[30%]">
                      <p className="text-text-lightGray font-medium text-sm text-start flex">
                        {translate('operation.photos')}
                      </p>
                    </div>

                    <div className=" w-[70%] flex items-center space-x-2">
                      <input
                        type="text"
                        placeholder="Enter Google Drive Link"
                        className="w-full px-3 py-2 border border-customBorder-border rounded text-sm text-text-primary placeholder:text-text-primary  bg-[var(--bgWhiteBackground)]"
                        onChange={(e) => {
                          setIsInputBoxChange(true);
                          setGoogleDriverLink(e.target.value);
                        }}
                        defaultValue={apiResponse?.googleDriverLink}
                      />
                      {/* textColor */}
                      <button
                        className="text-textColor hover:text-textColor"
                        onClick={() => {
                          googleDriverLinkSubmitHandler(googleDriverLink);
                        }}
                      >
                        {IsInputBoxChange === true ? (
                          <div>
                            <div className="block dark:hidden">
                              <CheckIcon />
                            </div>
                            <div className="hidden dark:block">
                              <CheckIconDark />
                            </div>
                          </div>
                        ) : (
                          <div>
                            <div className="block dark:hidden">
                              <EditIcon />
                            </div>
                            <div className="hidden dark:block">
                              <EditIconDark />
                            </div>
                          </div>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </>
            )}
          </Accordion>
        </div>

        {/* Flight section */}
        <div className="mt-4">
          <FlightSections
            selectedDate={selectedDate}
            ownerId={selectedLocation.OwnerId}
            openModal={openModalFlight}
            closeModal={closeModal}
            onPilotChangeRefetchTrigger={isPilotLoading}
          />
        </div>

        {activeModal === 'EditFormFlight' && flightDetail && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-80 z-50 p-2">
            <EditFormFlight
              title="Edit Flight"
              balloonName={flightDetail?.formattedBalloonName}
              capacity={flightDetail?.maxPax}
              allocatedPax={flightDetail?.allocatedPax}
              launchTime={`${flightDetail.balloonTakeoffTime}`}
              landTime={`${flightDetail?.balloonLandTime}`}
              fuel={flightDetail?.fuelUsed}
              closeModal={closeModal}
              onConfirm={(data) => console.log('Form Submitted:', data)}
              operationId={flightDetail?.operationId}
              operationBalloonId={flightDetail?.operationBalloonId}
              onAfterSubmit={modalCallback}
            />
          </div>
        )}

        {/* Allocations Section */}

        <DriverComponent
          routes={apiResponse?.routeList || []}
          buses={apiResponse?.busList || []}
          balloons={apiResponse?.balloonList || []}
          date={selectedDate}
        />

        {/* Pilot Allocation */}
        <Accordion
          title="Pilot Allocation"
          iconOpen={
            <div>
              <div className="block dark:hidden">
                <AccordianDownIcon />
              </div>
              <div className="hidden dark:block">
                <AccordianDownIconDark />
              </div>
            </div>
          }
          iconClose={
            <div>
              <div className="block dark:hidden">
                <AccordianUpIcon />
              </div>
              <div className="hidden dark:block">
                <AccordianUpIconDark />
              </div>
            </div>
          }
          icon={
            <div>
              <div className="block dark:hidden">
                <AddFormIcon />
              </div>
              <div className="hidden dark:block">
                <AddFormIconDark />
              </div>
            </div>
          }
          accordionIsOpen={pilotAccordionIsOpen}
          toggleState={setPilotAccordionIsOpen}
          formComponent={
            <PilotForm
              heading="Add Pilot"
              closeModal={closeModal}
              balloons={apiResponse?.balloonList || []}
              crewVehicleList={apiResponse?.crewVehicleList || []}
              onStaffChange={() => handleStaffChange('pilot')}
              staffAllocation={staffAllocation || null}
              date={selectedDate}
            />
          }
          bgColor={`${bgColor}`}
        >
          {isLoading || operationIsFetching ? (
            <>
              <div className="flex justify-center align-middle">
                <Loader />
              </div>
            </>
          ) : (
            <>
              <div className="bg-blue-50 space-y-4 mb-4 ">
                <div className="grid grid-cols-2 gap-4">
                  <div className="flex gap-4 items-center flex-col">
                    <label className="block text-textColorGray text-sm font-medium mb-1">
                      {translate('operation.total')}
                    </label>
                    <input
                      type="text"
                      className=" focus:outline-none focus:ring-0 focus:border-customBorder-border w-full border border-customBorder-border rounded p-2 text-sm  bg-backgroundColor-darkThemeColor text-text-secondary text-center"
                      value={apiResponse?.totalMaxPax?.totalMaxPax}
                      readOnly
                    />
                  </div>

                  {/* Flight Field */}
                  <div className="flex gap-4 items-center flex-col">
                    <label className="block text-textColorGray text-sm font-medium mb-1">
                      {translate('operation.flight')}
                    </label>
                    <input
                      type="text"
                      className="focus:outline-none focus:ring-0 focus:border-customBorder-border w-full border border-customBorder-border rounded p-2 text-sm  bg-backgroundColor-darkThemeColor text-text-secondary text-center"
                      readOnly
                      value={apiResponse?.totalMaxPax?.totalAllocCount}
                    />
                  </div>

                  <div className="flex gap-4 items-center flex-col">
                    <label className="block text-textColorGray text-sm font-medium mb-1">
                      {translate('operation.balloonCount')}
                    </label>
                    <input
                      type="text"
                      className="focus:outline-none focus:ring-0 focus:border-customBorder-border w-full border border-customBorder-border rounded p-2 text-sm  bg-backgroundColor-darkThemeColor text-text-secondary text-center"
                      value={apiResponse?.totalMaxPax?.totalBalloons}
                      readOnly
                    />
                  </div>
                </div>

                {/* Flight Requirements Section */}
                <div className=" bg-sidebar-background p-4 rounded">
                  {/* Header */}
                  <div className="flex justify-between items-center mb-4">
                    <h2 className="text-textColor font-semibold text-sm">
                      {translate('operation.flightRequirements')}
                    </h2>
                    <button
                      className="text-textColor hover:text-textColor"
                      onClick={handleEditToggle}
                    >
                      {/* Edit Icon */}
                      <div>
                        <div className="block dark:hidden">
                          <EditIcon />
                        </div>
                        <div className="hidden dark:block">
                          <EditIconDark />
                        </div>
                      </div>
                    </button>
                  </div>

                  {/* Temp Field */}
                  <div className="flex flex-col w-1/2 mb-4">
                    <label className="block text-textColorGray text-sm text-start font-medium mb-1">
                      {translate('operation.temp')}
                    </label>
                    <ReusableSelect<ITemperature>
                      options={(tempList || []).sort(
                        (a, b) => a.temperature - b.temperature,
                      )}
                      className={`w-full border border-customBorder-border rounded p-2 text-sm  bg-backgroundColor-darkThemeColor text-text-secondary  ${
                        !isEditing ? 'pointer-events-none opacity-50' : ''
                      }`}
                      getOptionLabel={(option: ITemperature) =>
                        `${option.temperature}°C`
                      }
                      getOptionValue={(option: ITemperature) =>
                        option.temperatureId
                      }
                      onChange={(selectedValue: ITemperature) => {
                        console.log(selectedValue, 'temp2 selected');
                        setSelectedTemperature2(selectedValue);
                        setTemp(selectedValue.temperatureId);
                        const data = {
                          temp1: selectedValue.temperatureId,
                          ownerId: selectedLocation.OwnerId,
                          toDate: encodeDateForUrl(selectedDate),
                        };
                        addTemperature(data); // API call
                      }}
                      value={temp || todayTemp || undefined}
                      placeholder="Select Temp2"
                      isDisabled={!isEditing}
                    />
                  </div>

                  {/* PIC Field */}
                  <div>
                    <label className="block text-textColorGray text-sm text-start font-medium mb-1">
                      {translate('operation.pic')}
                    </label>
                    <div className="flex items-center space-x-2">
                      <ReusableSelect<IDutyManager>
                        options={apiResponse?.picManager || []}
                        className={`w-full border border-customBorder-border rounded p-2 text-sm bg-backgroundColor-darkThemeColor text-text-secondary ${
                          !isEditing ? 'pointer-events-none opacity-50' : ''
                        }`}
                        getOptionLabel={(option) => {
                          const contact = [
                            '',
                            'null',
                            'undefined',
                            null,
                            undefined,
                          ].includes(option?.staffContact)
                            ? '--'
                            : option.staffContact;

                          return `${option.staffName ?? '--'} ${contact}`;
                        }}
                        getOptionValue={(option) => option.staffId}
                        onChange={handleDutyPicChange}
                        placeholder="Select Duty Manager"
                        value={selectedPic}
                        isDisabled={!isEditing} // Disable when not in edit mode
                      />

                      {/* Phone Icon */}
                      <button
                        className="text-textColor hover:text-textColor"
                        onClick={() => {
                          handlePhoneClick(phoneNumberPic);
                        }}
                      >
                        <div>
                          <div className="block dark:hidden">
                            <PhoneIcon />
                          </div>
                          <div className="hidden dark:block">
                            <PhoneIconDark />
                          </div>
                        </div>
                      </button>
                    </div>
                  </div>

                  <div className="mt-2">
                    <WeatherSection
                      selectedDate={selectedDate}
                      ownerId={selectedLocation.OwnerId}
                      isEditWeather={isEditWeather}
                      setIsEditWeather={setIsEditWeather}
                    />
                  </div>
                </div>
              </div>
            </>
          )}

          {isPilotLoading || isPilotFetching ? (
            <div className="flex justify-center align-middle">
              <Loader />
            </div>
          ) : staffAllocation && staffAllocation.length > 0 ? (
            <CrewPilotDetailsCard
              onOperationStaffIdChange={handleOperationStaffIdChange}
              openModal={openModal}
              crewList={staffAllocation}
              onStaffChange={() => handleStaffChange('pilot')}
            />
          ) : (
            <div className="text-center text-textColorGray p-4">
              {translate('operation.dataIsNotAvailable')}
            </div>
          )}
          {activeModal === 'PilotForm' && crewDetails && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-2">
              <PilotForm
                balloons={apiResponse?.balloonList || []}
                heading="Edit Pilots Details"
                closeModal={closeModal}
                crewVehicleList={apiResponse?.crewVehicleList || []}
                operationStaffId={operationStaffId}
                initialValues={crewDetails}
                onStaffChange={() => handleStaffChange('pilot')}
                staffAllocation={staffAllocation || null}
                date={selectedDate}
              />
            </div>
          )}
        </Accordion>

        {/* Crew Allocation */}
        <CrewComponent
          routes={apiResponse?.routeList || []}
          buses={apiResponse?.busList || []}
          balloons={apiResponse?.balloonList || []}
          date={selectedDate}
        />

        <OperationCheckListComponent date={selectedDate} />

        <div className={`rounded  ${bgColor}`}>
          <Accordion
            key={1}
            title={'Map'}
            // icon={<EditIcon style={{ cursor: 'pointer' }} />}
            bgColor={`${bgColor}`}
            onToggleEditMode={handleEditClick}
            iconOpen={
              <div>
                <div className="block dark:hidden">
                  <AccordianDownIcon />
                </div>
                <div className="hidden dark:block">
                  <AccordianDownIconDark />
                </div>
              </div>
            }
            iconClose={
              <div>
                <div className="block dark:hidden">
                  <AccordianUpIcon />
                </div>
                <div className="hidden dark:block">
                  <AccordianUpIconDark />
                </div>
              </div>
            }
          >
            <Accordion
              title="Allocations"
              bgColor=" bg-backgroundColor-darkThemeColor"
            >
              {isLoading ? (
                <div className="text-center p-4">
                  <span className="loader animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 inline-block" />
                  <div className="text-textColorGray mt-2">
                    Loading Allocations details...
                  </div>
                </div>
              ) : (
                <div className="flex justify-between">
                  <div>
                    <p className="text-sm text-textColorGray">Flight Max</p>
                    <p className="text-sm font-semibold text-textColor">
                      <span className="text-textColor">
                        {
                          apiResponse?.busFlightPaxAllocation?.flightMax
                            ?.totalAllocatedPax
                        }
                      </span>
                      /
                      {
                        apiResponse?.busFlightPaxAllocation?.flightMax
                          ?.totalCapacity
                      }
                    </p>
                  </div>
                  <div>
                    <p className="text-sm  text-textColorGray">
                      {translate('operation.busMax')}
                    </p>
                    <p className="text-sm font-semibold text-textColor">
                      <span className="text-textColor">
                        {
                          apiResponse?.busFlightPaxAllocation?.busMax
                            ?.totalAllocatedPax
                        }
                      </span>
                      /
                      {
                        apiResponse?.busFlightPaxAllocation?.busMax
                          ?.totalAllocatedPax
                      }
                    </p>
                  </div>
                  <div>
                    <p className="text-sm text-textColorGray">
                      {translate('operation.earlyReturn')}
                    </p>
                    <p className="text-sm font-semibold text-textColor">
                      <span className="text-textColor">
                        {apiResponse?.earlyReturn?.booked}
                      </span>
                      /{apiResponse?.earlyReturn?.maximum}
                    </p>
                  </div>
                </div>
              )}
            </Accordion>

            {isLoading ? (
              <div className="flex justify-center align-middle">
                <Loader />
              </div>
            ) : apiResponse?.maxForUpDownHillForPdAndCairns &&
              apiResponse.maxForUpDownHillForPdAndCairns.length > 0 ? (
              apiResponse.maxForUpDownHillForPdAndCairns.map(
                (details: IMaxMinPaxForPd, index: number) => (
                  <Accordion
                    key={index}
                    title={details?.transferRouteName}
                    bgColor="bg-backgroundColor-darkThemeColor"
                  >
                    <div className="flex justify-between">
                      <div>
                        <p className="text-sm text-text-lightGray">
                          {translate('operation.pickupMax')}
                        </p>
                        <p className="text-sm font-semibold text-textColor">
                          <span className="text-textColor">
                            {details?.busPickupCurrent}
                          </span>
                          /{details?.busPickupMax}
                        </p>
                      </div>
                      <div>
                        <p className="text-sm text-text-lightGray">
                          {translate('operation.dropOffMax')}
                        </p>
                        <p className="text-sm font-semibold text-textColor">
                          <span className="text-textColor">
                            {details?.dropoffCurrent}
                          </span>
                          /{details?.dropoffMax}
                        </p>
                      </div>
                    </div>
                  </Accordion>
                ),
              )
            ) : (
              <div className="text-center text-textColorGray p-4">
                {translate('operation.dataIsNotAvailable')}
              </div>
            )}

            <div className="bg-blue-50 rounded shadow">
              <div className="flex justify-end items-center h-16 -mt-2 w-full">
                <div className="flex items-center rounded p-2 w-20 h-12 cursor-pointer gap-2 shadow  bg-backgroundColor-white">
                  {/* Map View Button */}
                  <div
                    className={`flex items-center justify-center w-10 h-10 rounded ${
                      isMapView
                        ? 'bg-listView-borderColor text-blue-600'
                        : 'bg-blue-200 text-blue-600'
                    }`}
                    onClick={() => setIsMapView(true)}
                  >
                    <div>
                      <div className="block dark:hidden">
                        <MapIcon />
                      </div>
                      <div className="hidden dark:block">
                        <MapIconDark />
                      </div>
                    </div>
                  </div>

                  {/* Map List View Button */}
                  <div
                    className={`flex items-center justify-center w-10 h-10 rounded ${
                      !isMapView
                        ? 'bg-listView-borderColor text-blue-600'
                        : 'bg-blue-200 text-blue-600'
                    }`}
                    onClick={() => setIsMapView(false)}
                  >
                    <div>
                      <div className="block dark:hidden">
                        <MapList />
                      </div>
                      <div className="hidden dark:block">
                        <MapListDark />
                      </div>
                    </div>
                    {/* <MapList /> */}
                  </div>
                </div>
              </div>
            </div>

            {isMapView ? (
              <div className=" bg-sidebar-background h-80 rounded overflow-hidden">
                <GoogleMapComponent date={selectedDate} />
              </div>
            ) : (
              <div className=" bg-sidebar-background h-80 rounded overflow-auto">
                <ListView data={[]} date={selectedDate} />
              </div>
            )}
          </Accordion>
        </div>
        <div className="mt-4">
          <Accordion
            title={'Payment Breakup'}
            bgColor={`${bgColor}`}
            iconOpen={
              <div>
                <div className="block dark:hidden">
                  <AccordianDownIcon />
                </div>
                <div className="hidden dark:block">
                  <AccordianDownIconDark />
                </div>
              </div>
            }
            iconClose={
              <div>
                <div className="block dark:hidden">
                  <AccordianUpIcon />
                </div>
                <div className="hidden dark:block">
                  <AccordianUpIconDark />
                </div>
              </div>
            }
          >
            <PaymentBreakup
              title="Payment Breakup"
              operationDate={selectedDate}
              ownerId={selectedLocation?.OwnerId}
              showHeading={false}
            />
          </Accordion>
        </div>

        <div className="mt-4">
          <Accordion
            title="Breakfast Pax"
            bgColor={`${bgColor}`}
            iconOpen={
              <div>
                <div className="block dark:hidden">
                  <AccordianDownIcon />
                </div>
                <div className="hidden dark:block">
                  <AccordianDownIconDark />
                </div>
              </div>
            }
            iconClose={
              <div>
                <div className="block dark:hidden">
                  <AccordianUpIcon />
                </div>
                <div className="hidden dark:block">
                  <AccordianUpIconDark />
                </div>
              </div>
            }
          >
            <div className={`relative ${bgColor} rounded`}>
              <BreakFast
                showHeading={false}
                selectedDate={encodeDateForUrl(selectedDate)}
                ownerId={selectedLocation?.OwnerId}
              />
            </div>
          </Accordion>
        </div>

        <div className="mt-4">
          <GeneralComment
            comments={[]}
            date={selectedDate}
            closeModal={closeModal}
          />
        </div>

        {/* Weather and travel status */}
        <WeatherAndTravelStatus
          bgColor={bgColor}
          ownerId={selectedLocation?.OwnerId}
          selectedDate={selectedDate}
        />
      </div>
    </div>
  );
};

export default MobileOperations;
